import "./Spinner.css";
const Spinner = ({ style }) => <div className="lds-dual-ring " style={style}></div>;

export default Spinner;
